import React from "react";
import { Form } from "react-final-form";
import { Field } from "react-final-form-html5-validation";
import classNames from "classnames";
import jMoment from "moment-jalaali";
import { Container, Row, Col, FormGroup, Form as BSForm } from "reactstrap";

import Button from "../Form/Button";
import Condition from "../Form/Condition";
import RadioButtonGroup from "../Form/RadioButtonGroup";
import DatePicker from "../Form/DatePicker";

import { searchTypes, loginStates } from "./reportsConfig";
import disableSubmit from "../../utils/disableSubmit";
import { enDigits, faDigits } from "../../utils/formatDigits";
import SearchTypeahead from "../Form/SearchTypeahead";

const AnalysisForm = props => {
  return (
    <Form
      onSubmit={values =>
        props.onSubmit({
          startDate: enDigits(values.startDate),
          endDate: enDigits(values.endDate),
          loginState: values.loginState,
          type: values.type,
          id:
            values.type && values.type !== "all" && values.search.length
              ? values.search[0].id
              : null,
          search: values.search
        })
      }
      subscription={{
        submitting: true,
        pristine: true,
        errors: true,
        values: true
      }}
      initialValues={{
        startDate:
          (props.options.startDate && faDigits(props.options.startDate)) ||
          jMoment()
            .subtract(1, "day")
            .format("jYYYY-jM-jD"),
        endDate: (props.options.endDate && faDigits(props.options.endDate)) || jMoment().format("jYYYY-jM-jD"),
        type: props.options.type || "all",
        search: props.options.search || [],
        loginState: props.options.loginState || "3"
      }}
      render={({ handleSubmit, submitting, pristine, errors, values }) => (
        <BSForm
          id="analysis-form"
          onSubmit={handleSubmit}
          className={classNames({ disabled: submitting })}
        >
          <Container fluid>
            <Row form>
              <Col xs="12" md="2">
                <Field
                  name="startDate"
                  id="start-date"
                  required
                  label="از تاریخ"
                  valueMissing="این قسمت نمی‌تواند خالی باشد"
                  component={DatePicker}
                  placeholder="مثلاً: ۲۰-۱۲-۱۳۹۷"
                  className="rtl-placeholder text-left"
                  dir="ltr"
                />
              </Col>
              <Col xs="12" md="2">
                <Field
                  name="endDate"
                  id="end-date"
                  required
                  label="تا تاریخ"
                  valueMissing="این قسمت نمی‌تواند خالی باشد"
                  component={DatePicker}
                  placeholder="مثلاً: ۲۰-۱۲-۱۳۹۷"
                  className="rtl-placeholder text-left"
                  dir="ltr"
                />
              </Col>
              <Col>
                <Field
                  name="type"
                  id="type"
                  required
                  label="جستجو در"
                  valueMissing="این قسمت نمی‌تواند خالی باشد"
                  component={RadioButtonGroup}
                  options={searchTypes}
                  small={values.type !== "all"}
                />
                <Condition when="type" isNot="all">
                  <FormGroup>
                    <Field
                      name="search"
                      id="search"
                      required
                      searchType={values.type}
                      label={searchTypes[values.type].label}
                      valueMissing="این قسمت نمی‌تواند خالی باشد"
                      placeholder={
                        props.options.search && props.options.search[0] && props.options.search[0].name
                      }
                      component={SearchTypeahead}
                    />
                  </FormGroup>
                </Condition>
              </Col>
              <Col>
                <Field
                  name="loginState"
                  id="login-state"
                  required
                  label="نوع کاربران"
                  valueMissing="این قسمت نمی‌تواند خالی باشد"
                  component={RadioButtonGroup}
                  options={loginStates}
                />
              </Col>
              <Col
                className="form-group d-flex flex-column justify-content-end"
              >
                <Button
                  block
                  disabled={disableSubmit({
                    submitting,
                    pristine: false,
                    errors
                  })}
                  loading={submitting}
                  color="success"
                >
                  دریافت گزارش
                </Button>
              </Col>
            </Row>
          </Container>
        </BSForm>
      )}
    />
  );
};
export default AnalysisForm;
